import { URL_API_UPDATE_DATABASE } from '~/utils/constants';
import axiosClient from './axiosClient';

export const updateDatabaseApi = {
  uploadDatabase(payload: FormData) {
    const url = `${URL_API_UPDATE_DATABASE.UPDATE_DATABASE}`;
    return axiosClient.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};
